import {
  EntityList,
  EntityListProps,
  renderDate,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving, User } from 'gql.generated'
import { Box } from 'grid'
import { ConstrainMode, IGroup, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'
import { ParticipantListItem } from 'views/ParticipantViews'

export type ArchiveDeclinedCanceledListProps =
  EntityListProps<ParticipantListItem> & {
    groups: IGroup
  }

export const ArchiveDeclinedCanceledList: React.FunctionComponent<
  ArchiveDeclinedCanceledListProps
> = ({ items, groups, ...props }) => {
  const { t } = useTranslation()

  const fieldColumn = createFieldColumn(t)
  const columns = [
    fieldColumn('status', {
      onRender: renderStatusIcon,
      ungroupable: true,
    }),
    fieldColumn('id', { ungroupable: true }),
    fieldColumn('dateFrom', {
      onRender: renderDate,

      ungroupable: true,
    }),
    fieldColumn('dateTo', {
      onRender: renderDate,
      ungroupable: true,
    }),

    fieldColumn('title', {
      ungroupable: true,
    }),
    fieldColumn('provingGround.title', {
      onRender: (item, i, col) => {
        return `${item.provingGround && item.provingGround.title}, ${
          item.provingGround && item.provingGround.countryCode
        }`
      },
      ungroupable: true,
      getGroupValue: (item: Proving) =>
        `${item.provingGround!.title}, ${item.provingGround!.countryCode}`,
    }),
    fieldColumn('responsible', {
      onRender: (item, i, col) => {
        return (
          <div key={i}>
            {item.responsible.map((user: User, a: any) => {
              return (
                <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                  {user.name}
                </Box>
              )
            })}
          </div>
        )
      },
      // getGroupValue: (item: Proving) => {
      //   let result = ''
      //   if (item.responsible) {
      //     item.responsible.forEach((user: User) => {
      //       result = `${result} ${user.name}`
      //     })
      //   }
      //   return result
      // },
      ungroupable: true,
      minWidth: 105,
    }),
    fieldColumn('department', { ungroupable: true }),
  ]

  return (
    <>
      <EntityList
        items={items}
        groups={groups}
        stickyHeader={true}
        columns={columns}
        alternate={true}
        selectionMode={SelectionMode.multiple}
        constrainMode={ConstrainMode.horizontalConstrained}
        {...props}
      />
    </>
  )
}
